import React from 'react';
import { APP_PATH } from 'config';
import Layout from 'view/Layout';
import Login from 'view/Login';
import ErrorPage404 from 'view/ErrorPage/ErrorPage404';
import MonitorPage from 'view/Mon';
import AuthPage from 'view/AuthPage';
import AuthLinePage from 'view/AuthLinePage';
import LogoutPage from 'view/ErrorPage/LogoutPage';
import IrouterData from './type';
import { EnumAppRouter } from './enum';

const APP_ROUTER: IrouterData[] = [
  { url: `${APP_PATH}/*`, component: <Layout /> },
  { url: EnumAppRouter.驗證頁, component: <AuthPage /> },
  { url: EnumAppRouter.登入, component: <Login /> },
  { url: EnumAppRouter.錯誤頁, component: <ErrorPage404 /> },
  { url: EnumAppRouter.登出頁, component: <LogoutPage /> },
  { url: EnumAppRouter.監控頁, component: <MonitorPage /> },
  { url: EnumAppRouter.Line驗證頁, component: <AuthLinePage /> },
];

export default APP_ROUTER;
